import styled from 'styled-components';

import {
  fontFamilyBase,
  fontWeightMedium,
} from 'approot/shared/styles/typography.style';
import { STATIC_ASSETS } from 'webclient.constants';
import {
  LANGUAGE_CODE_AM_AM,
  LANGUAGE_CODE_KM,
  LANGUAGE_CODE_MY,
  LANGUAGE_CODE_TI_ET,
  LanguageCodes,
} from 'global/constants';

type GlobalStylesProps = {
  $language?: LanguageCodes;
};

export const GlobalStyles = styled.div<GlobalStylesProps>`
  @font-face {
    font-family: 'CalibreSchoolWeb';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src:
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-bold.woff)
        format('woff'),
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-bold.woff2)
        format('woff2'),
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-bold.eot) format('eot');
  }

  @font-face {
    font-family: 'CalibreSchoolWeb';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src:
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-semibold.woff)
        format('woff'),
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-semibold.woff2)
        format('woff2'),
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-semibold.eot)
        format('eot');
  }

  @font-face {
    font-family: 'CalibreSchoolWeb';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src:
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-medium.woff)
        format('woff'),
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-medium.woff2)
        format('woff2'),
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-medium.eot)
        format('eot');
  }

  @font-face {
    font-family: 'CalibreSchoolWeb';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src:
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-regular.woff)
        format('woff'),
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-regular.woff2)
        format('woff2'),
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-regular.eot)
        format('eot');
  }

  @font-face {
    font-family: 'CalibreSchoolWeb';
    font-style: normal;
    font-weight: 300;
    src:
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-light.woff)
        format('woff'),
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-light.woff2)
        format('woff2'),
      url(${STATIC_ASSETS}/fonts/v2/calibre-r-school-web-light.eot)
        format('eot');
  }

  @font-face {
    font-family: 'NSWHandwriting';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: url(${STATIC_ASSETS}/fonts/edu-nsw-act-foundation-400.woff2)
      format('woff2');
  }

  @font-face {
    font-family: 'NSWHandwriting';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url(${STATIC_ASSETS}/fonts/edu-nsw-act-foundation-600.woff2)
      format('woff2');
  }

  @font-face {
    font-family: 'Noto Sans Ethiopic';
    src: url(${STATIC_ASSETS}/fonts/NotoSansEthiopic-Regular.ttf)
      format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Noto Sans Myanmar';
    src: url(${STATIC_ASSETS}/fonts/NotoSansMyanmar-Regular.ttf)
      format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Noto Sans Khmer';
    src: url(${STATIC_ASSETS}/fonts/NotoSansKhmer-Regular.ttf)
      format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  ${({ $language }) => {
    if (
      $language === LANGUAGE_CODE_AM_AM ||
      $language === LANGUAGE_CODE_TI_ET
    ) {
      return `
        font-family: 'Noto Sans Ethiopic', ${fontFamilyBase};
        @font-face {
          font-family: 'NSWHandwriting';
          src: url(${STATIC_ASSETS}/fonts/NotoSansEthiopic-Regular.ttf) format('truetype');
        }
        @font-face {
          font-family: 'CalibreSchoolWeb';
          src: url(${STATIC_ASSETS}/fonts/NotoSansEthiopic-Regular.ttf) format('truetype');
        }
      `;
    }
    if ($language === LANGUAGE_CODE_MY) {
      return `
        font-family: 'Noto Sans Myanmar', ${fontFamilyBase};
        @font-face {
          font-family: 'NSWHandwriting';
          src: url(${STATIC_ASSETS}/fonts/NotoSansMyanmar-Regular.ttf) format('truetype');
        }
        @font-face {
          font-family: 'CalibreSchoolWeb';
          src: url(${STATIC_ASSETS}/fonts/NotoSansMyanmar-Regular.ttf) format('truetype');
        }
      `;
    }
    if ($language === LANGUAGE_CODE_KM) {
      return `
        font-family: 'Noto Sans Khmer', ${fontFamilyBase};
        @font-face {
          font-family: 'NSWHandwriting';
          src: url(${STATIC_ASSETS}/fonts/NotoSansKhmer-Regular.ttf) format('truetype');
        }
        @font-face {
          font-family: 'CalibreSchoolWeb';
          src: url(${STATIC_ASSETS}/fonts/NotoSansKhmer-Regular.ttf) format('truetype');
        }
      `;
    }
    return `font-family: ${fontFamilyBase};`;
  }}

  strong {
    font-weight: ${fontWeightMedium};
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  img {
    -prince-image-magic: snap-to-integer-coords;
  }
`;

export const InvisiblePrintWrapper = styled.div`
  position: absolute;
  left: -9999px;
  top: -9999px;
`;
